// Metadata cho các bộ câu hỏi — dùng ở mọi nơi render tab/label.
// KEEP IN SYNC với backend BO_ENUM + PRD §6.1.B.
//
// M52 (2026-04-25): gỡ `bo_noi_quy` khỏi BO_ENUM vì tính năng Nội quy đã được
// tách riêng (trang /noi-quy + /admin/rules-modules). Bộ này không còn được
// render dưới dạng tab trong QuestionsPage.
// - BO_META GIỮ `bo_noi_quy` để label hiển thị đúng ở nơi khác (ví dụ
//   FlashcardPage — M34 vẫn sync rules_exam → flashcard_reviews với set_name
//   = 'bo_noi_quy'; label "Nội quy" cần render cho NV đọc).
// - BE CHECK constraint giữ `bo_noi_quy` trong enum — rules flashcard sync
//   sẽ không bị break. DB không đổi.

export const BO_ENUM = [
  'cho_duyet',
  'bo_1000k',
  'bo_1250k',
  'bo_nang_cao',
  'bo_ai_da_sua',
  'bo_ai_ngon',
];

// M327 (2026-07-31): Owner đổi tên 3 bộ thưởng — key DB GIỮ NGUYÊN, chỉ đổi label:
//   bo_1000k → "500k" | bo_1250k → "1000k" | bo_nang_cao → "1250k"
export const BO_META = {
  cho_duyet:    { label: 'Chờ duyệt',           short: 'Chờ duyệt',    tone: 'warn',    order: 1 },
  bo_1000k:     { label: 'Bộ câu hỏi 500k',     short: '500k',         tone: 'primary', order: 2 },
  bo_1250k:     { label: 'Bộ câu hỏi 1000k',    short: '1000k',        tone: 'primary', order: 3 },
  bo_nang_cao:  { label: 'Bộ câu hỏi 1250k',    short: '1250k',        tone: 'primary', order: 4 },
  // bo_noi_quy: legacy — giữ METADATA cho các nơi render label (FlashcardPage),
  // nhưng KHÔNG còn trong BO_ENUM (QuestionsPage không render tab).
  bo_noi_quy:   { label: 'Nội quy',             short: 'Nội quy',      tone: 'info',    order: 5 },
  bo_ai_da_sua: { label: 'AI đã sửa',           short: 'AI đã sửa',    tone: 'muted',   order: 6 },
  bo_ai_ngon:   { label: 'AI ngon',             short: 'AI ngon',      tone: 'success', order: 7 },
};

// 3 bộ thưởng — có Import/Export + kiểm tra + flashcard
export const BO_THUONG = new Set(['bo_1000k', 'bo_1250k', 'bo_nang_cao']);

// Bộ được phép là đích của move-bo (loại cho_duyet — không cho chiều ngược)
export const BO_MOVE_TARGETS = BO_ENUM.filter((b) => b !== 'cho_duyet');

export function boLabel(bo) { return BO_META[bo]?.label || bo; }
export function boShort(bo) { return BO_META[bo]?.short || bo; }
